<template>
  <v-card>
    <v-card-title>
      <v-layout>
        <v-flex></v-flex>
        <v-flex shrink>
          <v-btn icon :loading="loading" @click="$emit('onClose')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text>
      <div class="caption">Title</div>
      <v-text-field
        id="title"
        v-model="input.wrap_up"
        v-validate="'required'"
        :name="timestamp"
        data-vv-as="Title"
        outline
        single-line
        placeholder="Title"
        :hide-details="!errors.has(timestamp)"
        :error="errors.has(timestamp)"
        :error-messages="errors.first(timestamp)"
      ></v-text-field>
      <div class="text-xs-center">
        <v-btn color="grey" outline :loading="loading" @click="$emit('onClose')">{{
          $t('cancel')
        }}</v-btn>
        <v-btn color="primary" :loading="loading" @click="handleSave">{{ $t('Save') }}</v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'
import WrapUpMixin from './WrapUpMixin'
import { mapGetters } from 'vuex'
export default {
  mixins: [WrapUpMixin],
  inject: ['$validator'],
  data() {
    return {
      input: {
        page_id: '',
        wrap_up: '',
        wrap_up_route: []
      },
      timestamp: moment().format('x'),
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  methods: {
    async handleSave() {
      const result = await this.$validator.validateAll()
      if (!result) {
        this.goToErrorInput()
        return
      }
      this.loading = true
      const saveResult = await this.handleSaveWrapUp({
        pageid: this.selectedBot.pageid,
        currentWrapUp: this.input
      })
      if (saveResult) {
        this.$emit('onSave', this.input)
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/WrapUp/WrapUpParentManage.vue